export default __webpack_public_path__ + "assets/steve.png?847c439b89dc1a0c5996fcb0ae0e8a35";